import { useAppDispatch, useAppSelector } from '../../store/hooks/hooks';
import { setLanguage } from '../../store/slices/settingsSlice';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

export default function LanguageSwitcher() {
	const dispatch = useAppDispatch();
	const { i18n } = useTranslation();
	const language = useAppSelector((state) => state.settings.language);

	const toggleLanguage = () => {
		const newLang = language === 'ru' ? 'en' : 'ru';
		dispatch(setLanguage(newLang));
		i18n.changeLanguage(newLang);
	};

	const getButtonText = () => {
		return language === 'ru' ? 'RU' : 'EN';
	};

	return (
		<div className='lang-switcher-container'>
			<button
				className='lang-switcher-btn'
				onClick={toggleLanguage}
			>
				{getButtonText()}
			</button>
		</div >
	);
}